import { useQuery } from "@tanstack/react-query";
import { financeApi } from "../../lib/api";
import { queryKeys } from "../../lib/queryKeys";
import type { ImportProvider } from "../../lib/types";

const instructionStaleTimeMs = 5 * 60 * 1000;

// Renders the backoffice-managed instruction for the selected import
// provider. The HTML is sanitized server-side (nh3 allowlist) before it is
// stored, so it is safe to inject here.
export function ImportInstructions({ provider }: { provider: ImportProvider }) {
  const instructionQuery = useQuery({
    queryKey: queryKeys.importInstruction(provider),
    queryFn: () => financeApi.getImportInstruction(provider),
    staleTime: instructionStaleTimeMs,
    retry: false,
  });

  const contentHtml = instructionQuery.data?.content_html?.trim();
  if (!contentHtml) return null;

  return (
    <section className="import-instructions" aria-label="Import instructions">
      <div className="import-instructions-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />
    </section>
  );
}
